import { admin_modal_toggled } from './types';
import { workspace, backendUrl } from '../globals/environment';
import { fetchWithTokenRefresh } from './AuthActions';
import { getUsers } from './UsersActions';

export const toggleAdminModal = () => {
  return { type: admin_modal_toggled };
};

export const deactivateUser = (userId, deactivated = true) => {
  return async (dispatch, getState) => {
    try {
      const { authStore } = getState();
      const { headers } = authStore;

      const response = await dispatch(fetchWithTokenRefresh(`${backendUrl}/users/${userId}/access`, {
        method: 'PUT',
        body: JSON.stringify({
          workspace,
          deactivated
        }),
        headers
      }));

      if (!response.ok) throw new Error('Could not modify user\'s access');
      dispatch(getUsers(true));
    } catch (error) {
      console.log(error);
    }
  };
};

export const promoteUser = (userId, isAdmin = true) => {
  return async (dispatch, getState) => {
    try {
      const { authStore } = getState();
      const { headers } = authStore;

      const response = await dispatch(fetchWithTokenRefresh(`${backendUrl}/users/${userId}/admin`, {
        method: 'PUT',
        body: JSON.stringify({
          workspace,
          isAdmin
        }),
        headers
      }));

      if (!response.ok) throw new Error('Could not modify user\'s access');
      dispatch(getUsers(true));
    } catch (error) {
      console.log(error);
    }
  };
};

export const clearAchievements = (userId) => {
  return async (dispatch, getState) => {
    try {
      const { authStore } = getState();
      const { headers } = authStore;

      const response = await dispatch(fetchWithTokenRefresh(`${backendUrl}/achievements/${userId}/earned`, {
        method: 'DELETE',
        headers
      }));

      if (!response.ok) throw new Error('Could not modify user\'s access');
      dispatch(getUsers(true));
    } catch (error) {
      console.log(error);
    }
  };
};

export const addTag = (name) => {
  return async (dispatch, getState) => {
    try {
      const { authStore } = getState();
      const { headers } = authStore;

      const response = await dispatch(fetchWithTokenRefresh(`${backendUrl}/tags`, {
        method: 'POST',
        body: JSON.stringify({ name, image: '' }),
        headers
      }));

      if (!response.ok) throw new Error('Could not add tag');
      // dispatch(getTags(true));
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteTag = (id) => {
  return async (dispatch, getState) => {
    try {
      const { authStore } = getState();
      const { headers } = authStore;

      const response = await dispatch(fetchWithTokenRefresh(`${backendUrl}/tags/${id}`, {
        method: 'DELETE',
        headers
      }));

      if (!response.ok) throw new Error('Could not delete tag');
      // dispatch(getTags(true));
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateTag = (id, name) => {
  return async (dispatch, getState) => {
    try {
      const { authStore } = getState();
      const { headers } = authStore;

      const response = await dispatch(fetchWithTokenRefresh(`${backendUrl}/tags/${id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ name })
      }));

      if (!response.ok) throw new Error('Could not update tag');
      // else dispatch({ type: tag_updated });
    } catch (error) {
      console.log(error);
    }
  };
};


// WEBPACK FOOTER //
// ./src/actions/AdminActions.js